import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export async function fetchSubscriptionPlans() {
    const res = await axios.get(`${API_URL}/core/subscription/plans`);
    return res.data;
}